import React from 'react'

import useApi from '../../../hooks/useApi'
import useOpenCertificate from '../../../hooks/useOpenCertificate'
import { apiCertificateAvailability } from '../../../utils/calibrationCertificate'
import { DocumentationTile } from './adasInsights'

const CERTIFICATE_TITLE = 'Calibration Certificate'

// US-40351 — the report's Calibration Certificate as a documentation row. The
// API decides eligibility (calibrationCertificate.available, sent beside
// vehicleReport in the report read, not inside it) with or
// without a session, so share-link visitors see it too. The PDF is rendered on
// click, never stored; the API re-checks and answers 409 { reason }, which
// useOpenCertificate shows in the toast.
const CertificateDocumentation = ({ report, calibrationCertificate }) => {
  const { adasReportService } = useApi()
  const { openCertificate, isLoading } = useOpenCertificate(() => adasReportService.viewCertificateUrl({ id: report._id }))

  if (!apiCertificateAvailability(calibrationCertificate)) return null

  return (
    <div className='adas-detail__additional-docs'>
      <h4 className='adas-detail__additional-docs-title'>Documentation</h4>
      <div className='adas-detail__doc-tiles-grid'>
        <DocumentationTile
          title={CERTIFICATE_TITLE}
          showDomainTag={false}
          rows={[{
            name: isLoading ? 'Loading…' : CERTIFICATE_TITLE,
            type: 'pdf',
            onClick: openCertificate,
            disabled: isLoading,
          }]}
        />
      </div>
    </div>
  )
}

export default CertificateDocumentation
